module.exports = __webpack_public_path__ + "static/media/logo-emiliaromagnaturismo-it.5301a08e.svg";